var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-container bg-red-500 h-48"},[_c('h1',{staticClass:"mt-20"},[_vm._v("Ups no existe nada acá")])])}]

export { render, staticRenderFns }